import { Action } from 'shared/store/types';
import actions from './actionTypes';
import { CouponsState, CouponListProps } from './types';

export const defaultState: CouponsState = {
  couponsList: [],
  couponDescription: null,
  isCollectLoading: false,
  isDetailsLoading: false,
  isError: false,
  showCollectCard: false,
  isBestPriceEnabled: false,
  isCouponLoading: true,
};

const couponReducer = (state = defaultState, action: Action) => {
  const { type, payload } = action;

  switch (type) {
    case actions.FETCH_COUPONS_AND_OFFERS_SUCCESS:
      return { ...state, couponsList: payload, isCouponLoading: false };
    case actions.FETCH_COUPONS_AND_OFFERS_FAILED:
      return { ...state, isCouponLoading: false };
    case actions.SET_IS_BESTPRICE:
      return { ...state, isBestPriceEnabled: payload };

    case actions.FETCH_COUPON_DESCRIPTION_INIT:
      return { ...state, isDetailsLoading: true, isError: false };

    case actions.FETCH_COUPON_DESCRIPTION:
      return { ...state, couponDescription: payload, isDetailsLoading: false };

    case actions.FETCH_COUPON_DESCRIPTION_ERROR:
      return { ...state, isDetailsLoading: false, isError: true };

    case actions.FETCH_COLLECT_COUPON_INIT:
      return {
        ...state,
        isCollectLoading: true,
        showCollectCard: false,
        isError: false,
      };

    case actions.FETCH_COLLECT_COUPON:
      return {
        ...state,
        couponsList: state.isBestPriceEnabled
          ? state.couponsList.map(
              (obj: { couponId: number }) =>
                payload.find(
                  (newObj: { couponId: number }) =>
                    newObj.couponId === obj.couponId
                ) || obj
            )
          : payload,
        isCollectLoading: false,
        showCollectCard: true,
      };

    case actions.FETCH_COLLECT_COUPON_ERROR:
      return {
        ...state,
        isCollectLoading: false,
        isError: true,
        showCollectCard: true,
      };

    case actions.TOGGLE_COLLECT_CARD:
      return { ...state, showCollectCard: false, isError: false };

    case actions.FETCH_DECOLLECT_COUPON:
      return { ...state, couponsList: payload };

    case actions.REFRESH_COUPONS: {
      const previousCoupons: CouponListProps = state.couponsList;
      const updatedCoupons: CouponListProps[] = [];
      previousCoupons.map((previousCoupon) => {
        payload.map((coupon) => {
          if (previousCoupon.couponId === coupon.couponId) {
            previousCoupon = {
              ...previousCoupon,
              ...coupon,
            };
          }
        });
        updatedCoupons.push(previousCoupon);
      });
      return { ...state, couponsList: updatedCoupons };
    }

    default:
      return state;
  }
};

export default couponReducer;
